import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { AdminLayout } from "@/components/AdminLayout";
import Login from "@/pages/Login";
import GoogleSignIn from "@/pages/GoogleSignIn";
import ClerkAuthProvider from "@/components/auth/ClerkAuthProvider";
import { GoogleBridge } from "@/components/auth/GoogleBridge";
import Entries from "@/pages/Entries";
import IndividualReport from "@/pages/IndividualReport";
import PersonReport from "@/pages/PersonReport";
import GroupReport from "@/pages/GroupReport";
import Printables from "@/pages/Printables";
import ColoringSheet from "@/pages/ColoringSheet";
import DiyAssessment from "@/pages/DiyAssessment";
import WorkshopPack, { GrowthWorkbook } from "@/pages/WorkshopPack";
import CoachingGuide from "@/pages/CoachingGuide";
import SelfEvaluationWorkbook from "@/pages/SelfEvaluationWorkbook";
import Settings from "@/pages/Settings";
import PublicReport from "@/pages/PublicReport";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <ClerkAuthProvider>
        <GoogleBridge />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/sign-in/*" element={<GoogleSignIn />} />
          <Route path="/sign-up/*" element={<Navigate to="/sign-in" replace />} />
          <Route path="/report/:token" element={<PublicReport />} />
          <Route element={<AdminLayout />}>
            <Route path="/entries" element={<Entries />} />
            <Route path="/reports/individual/:id" element={<IndividualReport />} />
            <Route path="/reports/person/:personKey" element={<PersonReport />} />
            <Route path="/reports/group" element={<GroupReport />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="/printables" element={<Printables />} />
            <Route path="/printables/coloring" element={<ColoringSheet />} />
            <Route path="/printables/diy-assessment" element={<DiyAssessment />} />
            <Route path="/printables/workshop-pack" element={<WorkshopPack />} />
            <Route path="/printables/growth-workbook" element={<GrowthWorkbook />} />
            <Route path="/printables/coaching-guide" element={<CoachingGuide />} />
            <Route path="/printables/self-evaluation" element={<SelfEvaluationWorkbook />} />
          </Route>
          <Route path="*" element={<Navigate to="/entries" replace />} />
        </Routes>
        </ClerkAuthProvider>
      </BrowserRouter>
      <Toaster position="bottom-right" richColors />
    </AuthProvider>
  );
}

export default App;
